import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('group_of_values'),
    addNewGroup: defineMessage('add_new_group'),
    searchGroupOfValue: defineMessage('search_group_of_values'),
    noGroupsAdded: defineMessage('no_groups_added'),
    noGroupsFound: defineMessage('no_groups_found_matching_this_name'),
    groupName: defineMessage('group_name'),
    status: defineMessage('status_1'),
    fieldType: defineMessage('field_type_1'),
    values: defineMessage('values'),
    lastModified: defineMessage('last_modified'),
    modifiedBy: defineMessage('modified_by'),
    workflows: defineMessage('workflows'),
    archived: defineMessage('archived'),
    active: defineMessage('active'),
    account: defineMessage('account'),
};
